import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ConfirmDialogComponent} from './shared/components/modals/confirm-dialog/component/confirm-dialog.component';
import {Toast} from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ConfirmDialogComponent,
    Toast
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
}
